"use client";

import { tsv } from "@faire/slate/lib/tsv";
import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import React from "react";
import { createPortal } from "react-dom";

import { ModalHeaderBase } from "./ModalHeaderBase";
import { useModalHeaderContext } from "./ModalHeaderContext";

export const ModalStickyHeader: React.FC<
  React.PropsWithChildren<{ className?: string; alwaysVisible?: boolean }>
> = ({ children, className, alwaysVisible }) => {
  const { refs } = useFloatingContext();
  const { stickyRef, showStickyHeader } = useModalHeaderContext();

  const headerCls = headerStyle.cls({
    visible: alwaysVisible || showStickyHeader,
    className,
  });

  if (!refs.floating) {
    return null;
  }

  return createPortal(
    <ModalHeaderBase className={headerCls} ref={stickyRef} aria-hidden>
      {children}
    </ModalHeaderBase>,
    refs.floating
  );
};

const headerStyle = tsv({
  base: "fs-modal__header--sticky border-fs-border-muted border-b-[0.5px] shadow-(--fs-modal-header-shadow)",
  variants: {
    visible: {
      true: "fs-modal__header--visible",
      false: "fs-modal__header--hidden",
    },
  },
});
